var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('Head'),_c('MapGIS',{attrs:{"mapKey":"bdmap"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }